import {
  SubscriptionsProps,
  SubscriptionEntity
} from 'src/components/SubscriptionsCard/types';
import { EntityType, FulfillmentStatus } from 'src/utils/enums';
import isDeliveredOrShipped from './isDeliveredOrShipped';
import sortFulfillments from './sortFulfillments';
import { SubscriptionType } from '@uma/react-commons/dist/index';
import { getEntity } from './getEntity';

interface HistoryContentReturn {
  status: FulfillmentStatus;
  shipmentDate: string;
}

const getLastShipment = (
  parts: any[],
  statusKey: string,
  dateKey: string
): HistoryContentReturn | null => {
  const lastShipment = parts
    ?.filter((part) => isDeliveredOrShipped(part?.[statusKey]))
    .sort(sortFulfillments)[0];

  if (!lastShipment) return null;

  return {
    status: lastShipment?.[statusKey],
    shipmentDate: lastShipment?.[dateKey]
  };
};

const getLastShipmentFromHistory = (
  entity: SubscriptionEntity
): HistoryContentReturn | null => {
  const parts = entity?.fulfillments
    ?.flatMap((fulfillment) => fulfillment?.parts || [])
    .flatMap((part) => part?.history || []);
  return getLastShipment(parts, 'status', 'timeStamp');
};

const getLastShipmentFromParts = (
  entity: SubscriptionEntity
): HistoryContentReturn | null => {
  const parts = entity?.fulfillments?.flatMap(
    (fulfillment) => fulfillment?.parts || []
  );
  return getLastShipment(parts, 'status', 'shipmentDate');
};

export const findLastShipmentForInk = (
  subscription: SubscriptionsProps
): HistoryContentReturn | null => {
  const entity = getEntity(subscription, EntityType.INSTANT_INK);
  if (!entity) return null;

  if (subscription?.type === SubscriptionType.INSTANT_INK) {
    return getLastShipmentFromHistory(entity);
  } else if (subscription?.type === SubscriptionType.HP_ALL_IN) {
    return getLastShipmentFromParts(entity);
  }

  return null;
};

export const findLastShipmentForPaper = (
  subscription: SubscriptionsProps
): HistoryContentReturn | null => {
  const entity = getEntity(subscription, EntityType.INSTANTPAPER);
  if (!entity) return null;

  if (subscription?.type === SubscriptionType.INSTANT_INK) {
    const firstFulfillment = entity?.fulfillments?.[0];
    if (!firstFulfillment?.shipmentDate) return null;
    return {
      status: FulfillmentStatus.SHIPPED,
      shipmentDate: firstFulfillment.shipmentDate
    };
  } else if (subscription?.type === SubscriptionType.HP_ALL_IN) {
    return getLastShipmentFromParts(entity);
  }

  return null;
};
